// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2VWzt","header":"MessagesList_header__d-VUH","chat":"MessagesList_chat__2OpEF"};